import comp from "./ExtractFromDoc";
export default comp;
